const doc = [({"en":({"js":({"admin":({"contacts":({"label":({"no_name":"Contact without a name"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;